module.exports = __webpack_public_path__ + "e6ee8bd2fab199c85f9125d2bfa61833.fbx";